/**
 * English translations for Plan tab
 * Centralized constants for consistent UI text across Plan page components
 */

export const PLAN_TRANSLATIONS = {
  // Action buttons
  createItems: 'Create Items',
  timelineReport: 'Timeline Report',
  hideProject: 'Hide Project Column',
  showProject: 'Show Project Column',
  hideCategories: 'Hide Categories Column',
  showCategories: 'Show Categories Column',
  reorder: 'Reorder',
  
  // Filters & Labels
  functions: 'Functions',
  gates: 'Gates',
  status: 'Status',
  projectStatus: 'Project Status',
  filterByStatus: 'Filter by Status',
  anchorDate: 'Anchor Date (T)',
  categories: 'Categories',
  groupByCategory: 'Group by Category',
  allProjects: 'All Projects',
  selectProject: 'Select project...',
  searchItems: 'Search items...',
  projects: 'projects',
  
  // Tooltips
  createItemsTooltip: 'Create new items for this project',
  noPermissionCreate: 'No permission to create items',
  timelineReportTooltip: 'Export simple timeline report (no gates)',
  reorderModeOn: 'Turn off reorder mode',
  reorderModeOff: 'Turn on reorder mode to drag and drop items',
  checkingPermissions: 'Checking permissions...',
  noPermissionReorder: 'No permission to reorder items',
  
  // Timeline Report Dialog
  reportDialogTitle: 'Timeline Report',
  reportSettings: 'Report Settings',
  reportTitle: 'Report Title',
  reportTitlePlaceholder: 'Enter report title...',
  sortOrder: 'Sort Order',
  sortByCurrent: 'Current Order - Keep drag & drop order',
  sortByCategory: 'Group by Categories - Auto group and sort',
  sortByCurrentDesc: 'Export PDF in the exact order shown on main screen',
  sortByCategoryDesc: 'Auto group items by categories and sort in predefined order',
  pageFormat: 'Page Format',
  landscape: 'Landscape (Horizontal) - Optimized for long timelines',
  portrait: 'Portrait (Vertical) - Suitable for short timelines',
  landscapeDesc: 'Display 90-120 days/page, suitable for large projects',
  portraitDesc: 'Display 45-60 days/page, suitable for small projects',
  showCategoryColors: 'Show Category Colors',
  showCategoryColumn: 'Show Category Column',
  exportPDF: 'Export PDF',
  cancel: 'Cancel',
  opening: 'Opening...',
  noItemsToReport: 'No items to report',
  checkFilters: 'Please check your filters',
  optimizedForLongTimeline: 'Optimized for Long Timelines',
  largeReport: 'Large Report',
  project: 'Project',
  
  // Summary Stats
  totalItems: 'Total Items',
  hasG4: 'Has G4',
  g5Complete: 'G5 = 100%',
  hasOverload: 'Overload',
  
  // Loading & Errors
  loadingItems: 'Loading items...',
  errorLoadingItems: 'Error Loading Items',
  
  // Settings Toggle
  hideSettings: 'Ẩn Cấu Hình',
  showSettings: 'Hiện Cấu Hình',
  
  // Date Range Settings
  dateRange: 'Khoảng thời gian xuất',
  useCustomRange: 'Tùy chỉnh khoảng thời gian',
  fromDate: 'Từ ngày',
  toDate: 'Đến ngày',
  thisMonth: 'Tháng này',
  invalidDateRange: 'Ngày bắt đầu phải trước ngày kết thúc',
  
  // Width Settings
  stretchToFullWidth: 'Mở rộng timeline ra toàn bộ chiều rộng',
  stretchToFullWidthDesc: 'Khi bật, timeline sẽ tự động rộng ra để lấp đầy khổ giấy (tốt cho timeline ngắn)',
} as const;

/**
 * Type-safe translation helper
 * Usage: t('createItems') returns the English translation
 * Can be extended for i18n in the future without changing call sites
 */
export const t = (key: keyof typeof PLAN_TRANSLATIONS): string => PLAN_TRANSLATIONS[key];
